import React from "react";
import { FiTrash2 } from "react-icons/fi";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";

// import { Container } from './styles';

function BtnRemove({ onRemove, productName}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button onClick={handleClick}>
        <FiTrash2 style={{ fontSize: "20px" }} />
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <div>
          <DialogTitle>Tem certeza que deseja excluir o <strong>{productName}</strong> ?</DialogTitle>

          <DialogActions>
            <Button onClick={onRemove} color="secondary" autoFocus>
              Sim
            </Button>
            <Button onClick={() => handleClose()} color="default">
              Não
            </Button>
          </DialogActions>
        </div>
      </Popover>
    </>
  );
}

export default BtnRemove;
